import React from 'react';

import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Box } from './style';
import { RouterLink } from 'components/style';

export function SettingsProviderButton({ Icon, title, to, disabled = false, fullWidth = false, ...props }) {
  return (
    <Box component={disabled ? 'div' : RouterLink} className="container" to={to} {...props}>
      <Box className="icon-wrapper">
        <Icon style={{ width: fullWidth ? 'auto' : 'initial' }} />
      </Box>
      <Typography variant="caption">{title}</Typography>
    </Box>
  );
}

SettingsProviderButton.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  title: PropTypes.string,
  to: PropTypes.string,
  disabled: PropTypes.bool,
};

SettingsProviderButton.defaultProps = {
  title: '',
  to: '',
};
